import { toast } from "react-toastify";
import {auctionAddresss, eggAssetTokenId, nodeUrl} from './Constants';
const wavesTransaction = require('@waves/waves-transactions')

export async function initAuction(startPrice, instantPrice, assetId, description, bidderSeed) {
    const initAuctionTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "initAuction",
            args: [{ "type": "integer", "value": startPrice }, { "type": "integer", "value": instantPrice },
            { "type": "string", "value": description }, { "type": "string", "value": "true" }] //auction Id
        },
        payment: [{
            assetId: assetId, // egg asset toekn id
            amount: 1
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(initAuctionTx, nodeUrl);
        console.log('Auction created successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function cancelAuction(auctionId, bidderSeed) {
    const initAuctionTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "cancelAuction",
            args: [{ "type": "string", "value": auctionId }] //auction Id
        },
        payment: [{
            assetId: eggAssetTokenId, // egg asset toekn id
            amount: 1
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(initAuctionTx, nodeUrl);
        console.log('Auction cancelled successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function placeBid(auctionId, tokenAmount, bidderSeed) {
    const placeBidTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "placeBid",
            args: [{ "type": "string", "value": auctionId }] //auction Id
        },
        payment: [{
            assetId: eggAssetTokenId, // egg asset toekn id
            amount: tokenAmount
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(placeBidTx, nodeUrl);
        console.log('Bid placed successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function cancelBid(auctionId, bidId, bidderSeed) { //add payment if required
    const cancelBidTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "cancelBid",
            args: [{ "type": "string", "value": auctionId },  // Auction Id
            { "type": "string", "value": bidId }]   // Bid id
        },
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(cancelBidTx, nodeUrl);
        console.log('Bid cancel successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function instantBuy(auctionId, tokenAmount, bidderSeed) {
    const instantBuyTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "instantBuy",
            args: [{ "type": "string", "value": auctionId }]   // Auction id
        },
        payment: [{
            assetId: eggAssetTokenId, // egg asset toekn id
            amount: tokenAmount
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(instantBuyTx, nodeUrl);
        console.log('Instant buy successful: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function acceptBid(auctionId, bidId, bidAmount, bidderSeed) {
    const instantBuyTx = wavesTransaction.invokeScript({
        dApp: auctionAddresss,
        fee: 900000,
        call: {
            function: "acceptBid",
            args: [{ "type": "string", "value": auctionId },             // Auction id
            { "type": "string", "value": bidId }]                 //Bid id
        },
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(instantBuyTx, nodeUrl);
        console.log('Bid accepted successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}